if (!customElements.get('cw-campaign')) {
  customElements.define('cw-campaign', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.userPaused = false;
      this.inView = true;
      this.motionButton = this.querySelector('[data-motion-toggle]');
      this.colorButtons = Array.from(this.querySelectorAll('[data-color]'));
      this.colorPanels = Array.from(this.querySelectorAll('[data-color-panel]'));
      this.setAttribute('data-ready', '');
      if (this.motionButton) {
        this.motionButton.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          this.updateMotion();
        }, { signal });
      }
      this.reducedMotion.addEventListener('change', () => this.updateMotion(), { signal });
      document.addEventListener('visibilitychange', () => this.updateMotion(), { signal });
      if (this.colorPanels.length) {
        this.selectColor('white', false);
        this.querySelector('[data-color-controls]').hidden = false;
        this.colorButtons.forEach(button => {
          button.addEventListener('click', () => this.selectColor(button.dataset.color, true), { signal });
        });
      }
      this.updateMotion();
      if ('IntersectionObserver' in window) {
        this.visibilityObserver = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.updateMotion();
        }, { rootMargin: '80px' });
        this.visibilityObserver.observe(this);
        if (this.dataset.motion === 'true' && !this.reducedMotion.matches) {
          this.revealObserver = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (entry.isIntersecting) {
                entry.target.classList.remove('is-pending');
                this.revealObserver.unobserve(entry.target);
              }
            });
          }, { threshold: 0.08 });
          this.querySelectorAll('.cw-reveal').forEach(element => {
            if (element.getBoundingClientRect().top > window.innerHeight) {
              element.classList.add('is-pending');
              this.revealObserver.observe(element);
            }
          });
        }
      }
    }
    updateMotion() {
      const enabled = this.dataset.motion === 'true' && !this.reducedMotion.matches;
      const running = enabled && !this.userPaused && !document.hidden && this.inView;
      this.toggleAttribute('data-running', running);
      if (this.motionButton) {
        this.motionButton.hidden = !enabled;
        this.motionButton.textContent = this.userPaused ? this.dataset.playLabel : this.dataset.pauseLabel;
      }
      if (!enabled || this.userPaused) {
        this.querySelectorAll('.is-pending').forEach(element => element.classList.remove('is-pending'));
        this.colorPanels.forEach(panel => panel.getAnimations().forEach(animation => animation.cancel()));
      }
    }
    selectColor(color, animate) {
      this.colorButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.color === color)));
      this.colorPanels.forEach(panel => {
        panel.getAnimations().forEach(animation => animation.cancel());
        const active = panel.dataset.colorPanel === color;
        panel.hidden = !active;
        if (active && animate && this.hasAttribute('data-running')) {
          panel.animate([{ opacity: 0.3 }, { opacity: 1 }], { duration: 420, easing: 'ease-out' });
        }
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.visibilityObserver?.disconnect();
      this.revealObserver?.disconnect();
      this.colorPanels?.forEach(panel => panel.getAnimations().forEach(animation => animation.cancel()));
    }
  });
}
